import * as S from './style';

const HelloWorld: React.FC = () => {
    return(
        <S.Title>
            <div className='pedro'>
                Número A
            </div>
        </S.Title>
    );
}

export default HelloWorld;